import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApiService } from '../shared/rest-api.service';


@Injectable({
  providedIn: 'root'
})
export class TopNavbarService {

  endpoint = 'navigation';

  constructor(private api: RestApiService) { }

  /*getNavigationItems(): Observable<any[]> {
    return this.api.getList(this.endpoint);
  }

  getNavigationItem(id: string): Observable<any> {
    return this.api.getOne(this.endpoint, id);
  }*/

  getLinks(): Observable<any[]> {
    return this.api.getList(this.endpoint + '/links');
  }

}
